import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useIntl } from "react-intl";
import { Pill, TableView } from "@gpstrackit/gtc-react-controls";
import useLandmarkVisitData from "./hooks/useLandmarkVisitData";
import { createPortal } from 'react-dom';

//Actions
import useOptions from "Modules/dashboard/views/landmarkVisit/constants/options";

import './landmarkVisit.scss'
import { useDispatch, useSelector } from "react-redux";
import { getMethodToFormatDuration } from "Modules/reports/views/main/components/reportsTab/helper";
import MapModal from "Modules/.common/components/MapModal";
import { getLandmarksAndGeofences as getKmls } from 'Redux/actions';
import { endpoints } from "Core/defaultValues";

const LandmarkVisit = ({ item, update, changesFilters, setChangesFilters }) => {
  const { messages } = useIntl();
  const { user } = useSelector((state) => state.securityRedux);
  const { optionsTimeMetric } = useOptions(messages);
  const { durationFormat } = user;
  const durationFormatTime = getMethodToFormatDuration(durationFormat);
  const [dataToMap, setDataToMap] = useState({});
  const { total, data, moreRows, loading, handleChangePage } = useLandmarkVisitData(item, update,changesFilters, setChangesFilters);
  const portalRoot = document.querySelector('#portal-root');
  const jsonLandmark = useSelector((state) => state.catalogsRealtimeRedux.landmarks);
  const pathFile = `https://s3.amazonaws.com/${endpoints.PUBLIC_REPOSITORY_CODE}`
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getKmls());
  }, []);

  const createColumn = (key, title, render) => ({
    key,
    title,
    show: true,
    export: true,
    render,
  });
  
  const getIconLandmark = (item) => {
    const {landmark} = item;
    let url;
    if(landmark?.url){
        url = `${pathFile}/${landmark?.url}`
    }else{
      if(landmark?.color){
        url = `${pathFile}/kmls/flagicon/${landmark?.color}.png`;
      }else{
        url = `${pathFile}/kmls/flagicon/8677D9.png`
      }
    }
    return url;
  }

  const columns = [
    createColumn('landmark', messages['dashboardPanel_landmark'], (row) => (
      <div
        style={{ display: "flex", alignItems: "center" }}
        onClick={() => {
          const data = {
            show: true,
            landmark: jsonLandmark.find((item) => item.id == row?.landmark.landmarkId),
            title: row?.landmark.landmarkName,
            pointers: [],
          }
          if (!jsonLandmark.length) return;
          setDataToMap(data)
        }}
      >
        <img src={ getIconLandmark( row ) } className="groupItem-icon" style={ { width : "20px" , height : "20px" } }/>
        <p style={ { textDecoration : "underline" , cursor : "pointer" } }>
          <span style={ { padding: "0 5px 0 5px" }}>{row?.landmark.landmarkName}</span>
        </p>
      </div>
    )),
    createColumn('visits', messages['dashboardPanel_Visits'], (row) => (
      <div>{row?.visits}</div>
    )),
    createColumn('totalTime', messages['dashboardPanel_Total_Time'], (row) => (
      <div>{durationFormatTime(row?.totalTime, messages)}</div>
    )),
  ];

  const { timeMetric } = JSON.parse(item?.settings);

  return (
    <>
      <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <div>
          <Pill
            textField="name"
            item={{
              id: "test",
              name: "nameTest",
              color: "default-green",
              label: optionsTimeMetric.find((item) => item.id === timeMetric)?.name,
            }}
          />
        </div>
        <div style={{ flex: 1, minHeight: 0 }}>
          <TableView
            keyColumn="id"
            columns={columns}
            data={data}
            hideDragable
            disableItemSelection
            infiniteScroll
            inputSearch={false}
            loading={loading}
            moreRowsAvailable={moreRows}
            onChangePage={handleChangePage}
            noMoreItemsMessage={messages?.['noMoreItems'] || 'There are no more items'}
            rowsPerPage={25}
            total={total}
          />
        </div>
      </div>
      {createPortal(
        <MapModal
          hiddenButton
          {...dataToMap}
          hiddenTraffic={true}
          hiddenWeather={true}
          hiddenSearchMap={true}
          hideModal={() => {
            setDataToMap({ show: false })
          }}
          zoom={18}
        />, portalRoot
      )}
    </>
  );
};

export default LandmarkVisit;
